import React, { FC, ReactElement } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RonForm } from './Ron/RonForm'
import { ClientFormProps } from './types'
import '../Shared/Ant/App.less'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

export const ClientForm: FC<ClientFormProps> = ({
  states,
  disabledStates,
  restrictedStates,
  providers,
  selectedProviders,
  selectedRestrictions,
  companyId
}): ReactElement => {
  return (
    <QueryClientProvider client={queryClient}>
      <RonForm
        states={states}
        disabledStates={disabledStates}
        restrictedStates={restrictedStates}
        providers={providers}
        selectedProviders={selectedProviders}
        selectedRestrictions={selectedRestrictions}
        companyId={companyId}
      />
    </QueryClientProvider>
  )
}
